/**
 * Publish the legal footer's real rendered height to the CSS custom property
 * `--legal-footer-h`. The lobby column (`#lobby-view`) reserves exactly this
 * strip via `bottom: var(--legal-footer-h)`, so the panels can never sit under
 * the Terms / Privacy / Copyright links — at any language, font size, or
 * viewport width, including when the footer wraps to a second line on a narrow
 * screen. Pure measurement: no layout assumptions, fully responsive.
 */
(function () {
  const footer = document.getElementById('legal-footer');
  if (!footer) return;

  const root = document.documentElement;
  let last = 0;

  const apply = () => {
    const h = Math.ceil(footer.getBoundingClientRect().height);
    if (h > 0 && h !== last) {
      last = h;
      root.style.setProperty('--legal-footer-h', h + 'px');
    }
  };

  apply();

  // ResizeObserver catches font-load reflow, wrapping, and text changes; the
  // resize + languagechange listeners cover browsers/timings it can miss.
  if (typeof ResizeObserver === 'function') {
    new ResizeObserver(apply).observe(footer);
  }
  window.addEventListener('resize', apply, { passive: true });
  window.addEventListener('load', apply);
  window.addEventListener('moonfall:languagechange', () => setTimeout(apply, 50));
})();
